package org.hs_soft.runmynesto.pages.home.sub_page.template.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.dialog.dialog.AddRecordDialog
import org.hs_soft.runmynesto.pages.components.dialog.dialog.ErrorMsgDialog
import org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_general.component.color_pallet.ColorPallet
import org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_general.component.date_picker.DatePickerDialog
import org.hs_soft.runmynesto.pages.components.dialog.dialog.ImageAIDialog
import org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_general.component.AddProductToArticleDialog
import org.hs_soft.runmynesto.pages.home.sub_page.template.mvi.TemplateEvent
import org.hs_soft.runmynesto.pages.home.sub_page.template.mvi.TemplateState

@Composable
fun TemplateDialogs(
    state: TemplateState,
    windowSizeMode: WindowSizeModeEnum,
    event: (TemplateEvent) -> Unit
) {
    if (state.showAddRecordDialog) {
        AddRecordDialog(
            windowSizeMode = windowSizeMode,
            dialogTitle = Strings.current().addNewCategory,
            nameFieldTitle = Strings.current().name,
            numberFieldTitle = Strings.current().number,
            height =Dimen.addRecordDialogOneFieldHeight,
            nameHint = Strings.current().enterCategoryName,
            numberHint = Strings.current().enterCategoryNumber,
            nameValue = state.newRecordName,
            showNumberField = false ,
            isSubmitClickable = state.isAddNewRecordSubmitClickable,
            loading = state.addNewCategoryLoading,
            onNameValueChange = {
                event(TemplateEvent.OnChangeRecordName(it))
            },
            onCancelClick = {
                event(TemplateEvent.OnCancelAddingCategoryDialogClick)
            },
            onSubmitClick = {
                event(TemplateEvent.OnSubmitAddingCategoryDialogClick(windowSizeMode))
            },
            onBackgroundClick = {
                event(TemplateEvent.OnCancelAddingCategoryDialogClick)
            }
        )

    }

    if (state.showCalendarDialog) {

        DatePickerDialog(
            selectedDay = state.selectedDate,
            modifier = Modifier,
            calendarData = state.calendarData,
            onSelectDay = {
                event(TemplateEvent.OnSelectDate(it))
            },
            onBackgroundClick = {
                event(TemplateEvent.OnBackGroundClick)
            },
        )
    }

    if (state.showColorPalletDialog){
        ColorPallet(
            onColorClick = {
                event(TemplateEvent.OnPalletColorClick(it))
            },
            onBackgroundClick = {
                event(TemplateEvent.OnBackGroundClick)
            }
        )
    }

    if (state.showGenerateAIImgDialog)
    {
        ImageAIDialog(
            windowSizeMode=windowSizeMode,
            isSubmitClickable = state.imageAiGeneratorDescription.isNotEmpty()
                    && state.imageAiGeneratorUrl!= null,
            id = state.selectedCategory?.id?:"",
            description = state.imageAiGeneratorDescription,
            submitGeneratedImgLoading = state.submitGeneratedImgLoading,
            imgGeneratedUrl = state.imageAiGeneratorUrl,
            generateImgLoading = state.isImageAiGeneratorLoading,
            onDescriptionInputChange = {
                 event(TemplateEvent.OnChangeAiImageDescription(it))
            },
            onBackgroundClick = {
                event(TemplateEvent.SetGenerateAIImgDialogStatus(false))
            },
            onCancelClick = {
                event(TemplateEvent.SetGenerateAIImgDialogStatus(false))
            },
            onSubmitClick = {id,imgAiGeneratorUrl->
                event(TemplateEvent.OnSubmitNewImage(
                    id=id,
                    url=imgAiGeneratorUrl,
                ))
            },
            onGenerateImgClick={desc->
                event(TemplateEvent.GenerateTemplateImg(
                    description=desc,
                ))
            },
            onSelectImg = {url:String->
                event(
                    TemplateEvent.SetLocalCategoryImg(
                       url = url,
                ))
            }

        )
    }

    if (state.showArticleListDialog){

        AddProductToArticleDialog(
            searchedProductItems=state.searchedProducts,
            onBackgroundClick = {
                event(TemplateEvent.OnAddProductToArticleDialogBackgroundClick)
            },
            onItemClick = {
                event(TemplateEvent.AddNewProductToArticleList(it))
            }
        )
    }

    if (state.errorInfo!=null){
        ErrorMsgDialog(
            windowSizeMode = windowSizeMode,
            description =state.errorInfo,
            onDismissDialog = {
                event(TemplateEvent.DismissErrorDialog)
            }
        )
    }

}